import md5 from 'js-md5';
import {
  getToken,
  getExpireTime,
  getoldToken
} from "./auth";
import store from '../../store';

/**
 * 计算时间差
 * 结束时间 endtime
 * 类型 h-m-s时分秒 h时 m分 s秒
 * 开始时间 starttime
 */
export function counttime(endtime, type = "h-m-s", starttime) {
  //转换时间戳
  let end = new Date(endtime).getTime();
  var start;
  if (starttime) {
    start = starttime;
  } else {
    start = new Date().getTime(); //当前时间为准
  };
  var remain = end - start;
  switch (type) {
    case 'h-m-s':
      let h = parseInt(remain / 1000 / 60 / 60 % 24);
      let m = parseInt(remain / 1000 / 60 % 60);
      let s = parseInt(remain / 1000 % 60);
      return `${h}时${m}分${s}秒`
      break;
    case 'h':
      return h
      break;
    case 'm':
      return m
      break;
    case 's':
      let snum = parseInt(remain / 1000);
      return snum
      break;

  };
}
const token_key = 'qazwsxedcrfvtgb'; //密钥

/**
 * 比较两个时间
 */
export function compareDate(date1) {
  var oDate1 = new Date().getTime(); //当前时间
  var oDate2 = new Date(date1).getTime(); //传入时间
  if (oDate1 > oDate2) {
    return true //迟到了
  } else {
    return false
  }
}
/**
 * server_token 服务校验
 */
export function servertoken() {
  //当前时间戳
  const app_time = Math.round(new Date().getTime() / 1000);
  //加密
  const key = md5(md5(token_key) + md5(app_time.toString()))
  var config = {
    app_time: app_time,
    app_token: key
  };
  return config
}


/**
 * 检测登录
 * @param {*} token
 * @param {*} expiresTime
 * @param {*} isLog
 */
export function checkLogin() {
  let token = getToken(); //获取缓存token
  let expiresTime = getExpireTime(); //获取缓存过期时间
  let isLog = store.state.user.isLog;
  let res = token ? true : false; //判断token是否存在
  let res1 = isLog; //是否已经登录
  let res2 = res && res1; //同时满足
  if (res2) {
    let newTime = Math.round(new Date() / 1000);
    if (expiresTime < newTime) return false; //登录验证失败，已过期
  }
  return res2; //登录验证成功
}

/**
 * 格式化时间
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    return value.toString().padStart(2, '0')
  })
  return time_str
}
/**
 * 检测token是否过期
 */
export function checkToken() {
  let token = getoldToken(); //获取缓存token
  let expiresTime = getExpireTime(); //获取缓存过期时间
  let res = token ? true : false; //判断token是否存在
  let res1 = expiresTime ? true : false; //判断缓存过期时间是否存在
  let res2 = res && res1; //同时满足
  if (res2) {
    let newTime = Math.round(new Date() / 1000);
    if (expiresTime < newTime) return false; //登录验证失败，已过期
  }
  return res2;
}

export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

export function split_array(arr, len) {
  var a_len = arr.length;
  var result = [];
  for (var i = 0; i < a_len; i += len) {
    result.push(arr.slice(i, i + len));
  }
  return result;
}



// WEBPACK FOOTER //
// ./src/assets/js/utils.js